const initialState = {
  loading: false,
  error: false,
  message: '',
  code: null,
  puestos: [],
  puesto: '5',
  unidadNegocio: null,
  marca: null,
  marcas: [],
  fecha: null,
  indicadores: [],
  calificaciones: {},
  aux: [],
  columnas: [],
  fechaCierre: null,
  cantidadAPV: 0,
  ventasAPV: null,
  CambiosGuardados: true,
  save: false,
  reportesAbiertos: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'IS_SAVE':
      return {
        ...state,
        save: action.payload.save,
        message: action.payload.message,
      };
    case 'REPORTES_ABIERTOS':
      return {
        ...state,
        reportesAbiertos: action.payload.reportesAbiertos,
        message: action.payload.message,
      };
    case 'IS_ERROR':
      return {
        ...state,
        error: action.payload.error,
        message: action.payload.message,
      };
    case 'RESET_SAVE_OR_ERROR':
      return {
        ...state,
        error: false,
        message: '',
        save: false,
      };
    case 'RESET_DATA_EV':
      return initialState;
    case 'LOADING_EV':
      return {
        ...state,
        ...action.payload,
        loading: true,
        code: null,
        message: '',
      };
    case 'SAVE_DATA_EV':
      return {
        ...state,
        ...action.payload,
        loading: true,
        code: null,
        message: '',
      };
    case 'CHANGE_FILTER_EV':
      return { ...state, ...action.payload };
    case 'ERROR_DATA_EV':
      return { ...state, ...action.type, error: true, loading: false };
    case 'SUCCESS_DATA_EV':
      return {
        ...state,
        loading: false,
        error: false,
        indicadores: action.payload.indicadores,
        calificaciones: action.payload.calificaciones,
        fechaCierre: action.payload.fechaCierre,
        fechaValida: action.payload.fechaValida,
        ventasAPV: action.payload.ventasAPV,
      };
    case 'SUCCESS_DATA_EV_AUX':
      return {
        ...state,
        loading: false,
        error: false,
        aux: action.payload.aux,
        calificaciones: action.payload.calificaciones,
      };
    case 'RESET_DATA_INDICADOR':
      return initialState;
    case 'CHANGE_DATA_INDICADOR':
      return { ...state, ...action.payload, loading: false };
    case 'SUCCESS_PUESTOS_EV':
      return { ...state, ...action.payload };
    case 'SUCCESS_MARCAS_EV':
      return { ...state, ...action.payload };
    case 'SUCCESS_COLUMNAS_EV':
      return { ...state, ...action.payload };
    case 'SAVED_EV':
      return {
        ...state,
        ...action.payload,
        loading: false,
        CambiosGuardados: true,
      };
    case 'ERROR_SAVED_EV':
      return { ...state, ...action.payload, loading: false };
    case 'GET_APV':
      return { ...state, ...action.payload, loading: true };
    case 'SUCCES_GET_APV':
      return {
        ...state,
        loading: false,
        error: false,
        cantidadAPV: action.payload.cantidad,
      };
    case 'GET_APVS':
      return { ...state, ...action.payload, loading: true };
    case 'LOADING_MARCASEV':
      return {
        ...state,
        ...action.payload,
        loading: true,
        code: null,
        message: '',
      };

    default:
  }
  return state;
};
